import {prepareMonthArrow} from '@components/timeline-new/diagram/graph/task-box-link/month-arrow'
import {rowHeight} from '@components/timeline-new/timeline-new-store'
import {Point, TimelineScale} from '@components/timeline-new/types'
import {distance} from '@components/timeline-new/utils'
import {cn} from '@containers/html-utils'
import {l, M, m} from '../svg'
import {prepareDayArrow} from './day-arrow'
import {ArrowFn, ArrowType, Interval, IntervalFn} from './types'
import {prepareWeekArrow} from './week-arrow'
import {prepareYearArrow} from './year-arrow'

// Pixel alignment, all horizontal lines are on the 21-th pixel of a 40px tall row
export const centerToTop = rowHeight / 2 + 1

export const centerToBottom = rowHeight - centerToTop

export const arrowEnd = (x: number, y: number, dx = -3) =>
  cn(M(x, y), m(-3 + dx, -3), l(3, 3), l(-3, 3))

export const prepareButtonPlacement = (
  intervals: Interval[],
  p: Point
): [Point, boolean] => {
  let interval: Interval = {from: {x: 0, y: 0}, to: {x: 0, y: 0}}
  let d: number = Number.POSITIVE_INFINITY
  for (const iv of intervals) {
    const dd = Math.min(distance(p, iv.from), distance(p, iv.to))
    if (dd <= d) {
      d = dd
      interval = iv
    }
  }

  if (interval.from.x === interval.to.x) {
    const minY = Math.min(interval.from.y, interval.to.y)
    const maxY = Math.max(interval.from.y, interval.to.y)
    const y = Math.min(Math.max(p.y, minY), maxY)
    return [{x: interval.from.x, y}, true]
  } else {
    const minX = Math.min(interval.from.x, interval.to.x)
    const maxX = Math.max(interval.from.x, interval.to.x)
    const x = Math.min(Math.max(p.x, minX), maxX)
    return [{x, y: interval.from.y}, false]
  }
}

export const prepareArrow = (
  scale: TimelineScale,
  type: ArrowType
): [ArrowFn, IntervalFn] => {
  switch (scale) {
    case TimelineScale.Days:
      return prepareDayArrow(type)
    case TimelineScale.Weeks:
      return prepareWeekArrow(type)
    case TimelineScale.Months:
      return prepareMonthArrow(type)
    case TimelineScale.Years:
      return prepareYearArrow(type)
  }
}
